export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export class NotFoundError extends ApiError {
  constructor(id: string) {
    super(`note not found: ${id}`, 404, 'not_found');
    this.name = 'NotFoundError';
  }
}

export class ConflictError extends ApiError {
  constructor(id: string, expected: number, actual: number) {
    super(`version conflict for ${id}: expected ${expected}, got ${actual}`, 409, 'conflict');
    this.name = 'ConflictError';
  }
}

export class ValidationApiError extends ApiError {
  constructor(
    public readonly details: readonly { readonly path: string; readonly message: string }[],
  ) {
    super(`validation failed: ${details.map((d) => `${d.path}: ${d.message}`).join('; ')}`, 400, 'validation');
    this.name = 'ValidationApiError';
  }
}

export class NetworkError extends ApiError {
  constructor(cause?: unknown) {
    super(`network error${cause ? `: ${String(cause)}` : ''}`, 0, 'network');
    this.name = 'NetworkError';
  }
}

export class AbortedError extends ApiError {
  constructor() {
    super('request aborted', 0, 'aborted');
    this.name = 'AbortedError';
  }
}
